import { Locker } from 'src/app/models/locker.model';

export const lockers: Locker[] = [
];


